"use client";

import { useTranslations } from "@/i18n/client";
import { formatDate } from "@/lib/utils/dateUtils";
import clsx from "clsx";
import styles from "./index.module.css";
import { IOrder } from "./order";

interface IOrdersList {
  className?: string;
  orders: IOrder[];
  hasAccordian?: boolean;
}

export const useStatusText = (status: IOrder["status"]) => {
  const t = useTranslations("myAccount.accountPage.orders.status");

  switch (status) {
    case "archived":
      return t("archived");
    case "failed":
      return t("failed");
    case "ok":
      return t("ok");
    case "progress":
      return t("progress");
    case "untouched":
      return t("untouched");
    default:
      return t("unknown");
  }
};

export const OrderStatus = ({ status }: { status: IOrder["status"] }) => {
  return (
    <div className={styles.status}>
      <div
        className={clsx(styles.status__dot, styles?.[`status__dot__${status}`])}
      />
      <span>{useStatusText(status)}</span>
    </div>
  );
};

export const OrdersList = ({ orders, className }: IOrdersList) => {
  return orders.map(order => {
    return (
      <div key={order.order} className={styles.order}>
        <div className={styles.order__info}>
          <div className={styles.order__element}>
            <p className={clsx(className && className)}>#{order.order}</p>
          </div>
          <div className={styles.order__element}>
            <time
              dateTime={`${formatDate(order.date)}`}
              className={styles.order__date}
            >
              {formatDate(order.date)}
            </time>
          </div>
          <p>{order.totals.itemsTotalPrice}</p>
        </div>
      </div>
    );
  });
};
